import React from 'react';
import { Pagination as BootstrapPagination, Col, Row } from 'react-bootstrap';
import { useTranslation } from '../contexts/LocaleContext';

const PAGES_WINDOW = 10;

interface PaginationProps {
  currentPage: number;
  lastPage: number;
  /** Всего элементов (для счётчика «from–to из total») */
  totalCount?: number;
  /** Размер страницы (нужен вместе с totalCount для счётчика по элементам) */
  pageSize?: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  lastPage,
  totalCount,
  pageSize,
  onPageChange,
}) => {
  const t = useTranslation();
  if (lastPage <= 1) return null;

  const showItemsCounter =
    totalCount !== undefined && pageSize !== undefined && totalCount > 0;
  const from = showItemsCounter ? (currentPage - 1) * pageSize! + 1 : currentPage;
  const to = showItemsCounter ? Math.min(currentPage * pageSize!, totalCount!) : lastPage;
  const counterTotal = showItemsCounter ? totalCount! : lastPage;

  const startPage = Math.floor((currentPage - 1) / PAGES_WINDOW) * PAGES_WINDOW + 1;
  const endPage = Math.min(startPage + PAGES_WINDOW - 1, lastPage);

  const items = [];
  for (let i = startPage; i <= endPage; i++) {
    items.push(
      <BootstrapPagination.Item
        key={i}
        active={i === currentPage}
        onClick={(e) => {
          e.preventDefault();
          onPageChange(i);
        }}
        className="d-none d-md-inline-block"
      >
        {i}
      </BootstrapPagination.Item>
    );
  }

  return (
    <Row className="py-2 mt-auto">
      <Col>
        <nav aria-label="Page navigation" className="d-flex align-items-center justify-content-end flex-wrap gap-2">
          <span className="text-muted ms-2 d-none d-md-inline">
            {showItemsCounter && counterTotal === 0
              ? `0 ${t('paginationOf')} 0`
              : `${from}–${to} ${t('paginationOf')} ${counterTotal}`}
          </span>
          <BootstrapPagination className="mb-0">
            <BootstrapPagination.Prev
              disabled={currentPage <= 1}
              onClick={(e) => {
                e.preventDefault();
                if (currentPage > 1) onPageChange(currentPage - 1);
              }}
              aria-label="Previous"
            />
            {items}
            <BootstrapPagination.Next
              disabled={currentPage >= lastPage}
              onClick={(e) => {
                e.preventDefault();
                if (currentPage < lastPage) onPageChange(currentPage + 1);
              }}
              aria-label="Next"
            />
          </BootstrapPagination>
          
        </nav>
      </Col>
    </Row>
  );
};

export default Pagination;
